/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
    Datagrid,
    DateField,
    TextField,
    Filter,
    List,
    SearchInput,
    ReferenceInput,
    AutocompleteInput,
    ReferenceField,
} from 'react-admin';
import AvisStatutField from './fields/AvisStatutField';
import AvisStatutInput from './inputs/AvisStatutInput';
import ActionField from './fields/ActionField'; // Import the ActionField

const AvisFilter = (props: any) => (
    <Filter {...props}>
        {/* <SearchInput source="q" alwaysOn /> */}
        <AvisStatutInput
            source="status"
            label="resources.reviews.fields.status"
            alwaysOn
        />
        <ReferenceInput
            source="sender"
            label="resources.reviews.fields.sender"
            reference="users"
            sx={{
                '& .hide-filter': {
                    alignItems: 'center',
                    backgroundColor: 'red !important',
                    alignSelf: 'center',
                },
                '& .MuiIconButton-root': {
                    alignSelf: 'center',
                },
            }}
            alwaysOn
        >
            <AutocompleteInput
                optionText="name"
                emptyText="Tout"
                resettable
                sx={{
                    '& .MuiFilledInput-adornedEnd:hover': {
                        border: '1px solid #ccc !important',
                    },
                }}
            />
        </ReferenceInput>
        <ReferenceInput
            source="driver"
            label="resources.reviews.fields.livreur"
            reference="livreurs"
            alwaysOn
        >
            <AutocompleteInput optionText="name" emptyText="Tout" resettable />
        </ReferenceInput>
    </Filter>
);

const AvisList = (props: any) => {
    return (
        <List
            {...props}
            filters={<AvisFilter />}
            sort={{ field: 'created_at', order: 'DESC' }}
            perPage={10}
            exporter={false}
            bulkActionButtons={false}
            hasCreate={false}
        >
            <Datagrid optimized rowClick="show">
                <ReferenceField source="sender" reference="users">
                    <TextField source="name" />
                </ReferenceField>
                <TextField source="created_for" />

                <ReferenceField
                    source="for"
                    reference="livreurs"
                    label="resources.reviews.fields.livreur"
                >
                    <TextField source="name" />
                </ReferenceField>

                <ReferenceField
                    source="course"
                    reference="courses"
                    label="resources.reviews.fields.course"
                >
                    <TextField source="code" />
                </ReferenceField>
                <TextField source="note" />

                <TextField source="comment" />

                <AvisStatutField
                    source="status"
                    label="resources.courses.fields.statut"
                />
                <DateField
                    source="created_at"
                    type="date"
                    label="resources.courses.fields.created_at"
                    showTime
                    options={{
                        hourCycle: 'h23',
                    }}
                />
                <ActionField source="action" label="" />
            </Datagrid>
        </List>
    );
};

export default AvisList;
